const hsOrderTypes = require('./hsOrderTypes')

module.exports = {
  ...hsOrderTypes,
  SCHADEN: { api: 'SCHADEN', human: 'Schaden' },
  SONSTIGES: { api: 'SONSTIGES', human: 'Sonstiges' }
}
